import React from "react";
import {
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import Shop from "./screens/Shop";
import Group from "./screens/Products";
import ProductPage from "./screens/ProductPage";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import Home from "./screens/Home";
import ErrorScreen from "./screens/ErrorScreen/ErrorScreen";
import CheckingYear from "./screens/CheckingYear";
import UnderAge from "./screens/UnderAge";
import Login from "./screens/Login";
import Registration from "./screens/Registration";
import SuccessfulRegistration from "./screens/SuccessfulRegistration";
import Chart from "./screens/Chart";
import AdminPanel from "./screens/AdminPanel";
import UserProfile from "./screens/User";
import ForgotChangePassword from "./screens/ForgotChangePassword";
import Settings from "./screens/User/Settings";
import Cart from "./screens/User/Cart";
import Checkout from "./screens/User/Checkout";
import Favorites from "./screens/User/Favorites";
import ContactUs from "./screens/User/ContactUs";
import UpdateInfo from "./screens/User/Settings/UpdateInfo";
import MyOrders from "./screens/User/Settings/MyOrders";
import MyInvoices from "./screens/User/Settings/MyInvoices";
import PrivacyPolicyCli from "./screens/User/Settings/PrivacyPolicyCli";
import PaymentOptions from "./screens/User/PaymentOptions";
import PaymentShipment from "./screens/User/PaymentOptions/Payment/PaymentShipment";
import PaymentCard from "./screens/User/PaymentOptions/Payment/PaymentCard";
import { getCookie, removeCookie } from "./utils/cookie";
import jwt_decode from "jwt-decode";

const Navigation = () => {

  const ProtectedRoute = ({ children, ...props }) => {
    const token = getCookie("token");
    const decoded = token && jwt_decode(token);

    if (!decoded) {
      removeCookie('token');
      removeCookie('userName');
      removeCookie('isAdmin');
      removeCookie('userId');
      return <Navigate to='/login' replace />;
    }

    if(props.isAdminRequired && !decoded.isAdmin) return <Navigate to='/profile' replace />;

    return children;
  };
  
  return (
    <Routes>
      <Route exact path="/" element={<Home/>} />
      <Route exact path="/shop" element={<Shop/>} />
      <Route exact path="/group/:id" element={<Group/>} />
      <Route exact path="/group/:groupId/product/:productId" element={<ProductPage/>} />
      <Route
        path='/profile'
        element={
          <ProtectedRoute>
            <UserProfile />
          </ProtectedRoute>
        }
        />
      <Route
        path='/profile/settings'
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
        />
      <Route
        path='/profile/settings/update-info'
        element={
          <ProtectedRoute>
            <UpdateInfo />
          </ProtectedRoute>
        }
        />
      <Route
        path='/profile/settings/invoice'
        element={
          <ProtectedRoute>
            <MyInvoices />
          </ProtectedRoute>
        }
        />
      <Route
        path='/profile/settings/privacy-policy'
        element={
          <ProtectedRoute>
            <PrivacyPolicyCli />
          </ProtectedRoute>
        }
        />
      <Route
        path='/profile/settings/my-orders'
        element={
          <ProtectedRoute>
            <MyOrders />
          </ProtectedRoute>
        }
        />
      <Route
        path='/profile/settings/invoice-info'
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
        />
      <Route
        path='/profile/settings/history'
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
        />
      <Route
        path='/profile/cart'
        element={
          <ProtectedRoute>
            <Cart />
          </ProtectedRoute>
        }
        />
      <Route
        path='/profile/checkout'
        element={
          <ProtectedRoute>
            <Checkout />
          </ProtectedRoute>
        }
        />
      <Route
        path='/payment-options'
        element={
          <ProtectedRoute>
            <PaymentOptions />
          </ProtectedRoute>
        }
        />
      <Route
        path='/payment-card'
        element={
          <ProtectedRoute>
            <PaymentCard />
          </ProtectedRoute>
        }
        />
      <Route
        path='/payment-shipment'
        element={
          <ProtectedRoute>
            <PaymentShipment />
          </ProtectedRoute>
        }
        />
      <Route
        path='/profile/favorites'
        element={
          <ProtectedRoute>
            <Favorites />
          </ProtectedRoute>
        }
        />
      <Route
        path='/profile/contact-us'
        element={
          <ProtectedRoute>
            <ContactUs />
          </ProtectedRoute>
        }
        />
      <Route exact path="/forgot-password" element={<ForgotChangePassword/>} />
      <Route
        path='/change-password'
        element={
          <ProtectedRoute>
            <ForgotChangePassword />
          </ProtectedRoute>
        }
        />
      <Route exact path="/privacy-policy" element={<PrivacyPolicy/>} />
      <Route exact path="/login" element={<Login/>} />
      <Route exact path="/registration" element={<Registration/>} />
      <Route exact path="/successful-registration" element={<SuccessfulRegistration/>} />
      <Route exact path="/chart" element={<Chart/>} />
      <Route
        path="/admin-panel"
        element={
          <ProtectedRoute isAdminRequired={true}>
            <AdminPanel />
          </ProtectedRoute>
        }
        />
      <Route exact path="/checking-year" element={<CheckingYear/>} />
      <Route exact path="/under-age" element={<UnderAge/>} />
      <Route exact path="/*" element={<ErrorScreen/>} />
    </Routes>
  );
};

export default Navigation;
